import {
  SINGLE_PROFILE_ERROR,
  SINGLE_PROFILE_START,
  SINGLE_PROFILE_SUCCESS,
} from 'constants/action-types/profiles/singleProfile';

export default (state, { type, payload }) => {
  switch (type) {
    case SINGLE_PROFILE_START:
      return {
        ...state,
        singleProfile: {
          ...state.singleProfile,
          loading: true,
          error: null,
        },
      };
    case SINGLE_PROFILE_ERROR:
      return {
        ...state,
        singleProfile: {
          ...state.singleProfile,
          error: payload,
          loading: false,
        },
      };
    case SINGLE_PROFILE_SUCCESS:
      return {
        ...state,
        singleProfile: {
          ...state.singleProfile,
          data: payload,
          error: null,
          loading: false,
        },
      };
    default:
      return null;
  }
};
